import { Command } from '@/app/tracking/api';

export interface UpdateCourseScoreCommandPayload {
  score: {
    min: number
    max: number
    raw: number
  }
  alwaysOverwrite: boolean
}

export const UpdateCourseScoreCommandName = 'update-course-score' as const;
export type UpdateCourseScoreCommand =
      Command<typeof UpdateCourseScoreCommandName, UpdateCourseScoreCommandPayload>;
